//libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import RichText from '/react4xp/components/RichText'
import LinkList, { LinkListProps } from '/react4xp/components/LinkList'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
export interface HeroBannerProps {
    bgColor?: string
    isWhite?: boolean
    title?: string
    counter?: {
        textBefore?: string
        number?: string
        textAfter?: string
    }
    image?: {
        src: string
        srcMedium: string
        srcSmall: string
        alt?: string
    }
    content?: string
    cta?: LinkListProps
}

export default function HeroBanner({
    bgColor,
    isWhite,
    title,
    counter,
    image,
    content,
    cta
}: HeroBannerProps) {
    return (
        <Section
            bgColor={bgColor}
            paddingTop='small'
            className='idea-hero-banner'
        >

            {isNonWhitespaceString(title) && (
                <div className='idea-hero-banner__top white'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-10 offset-md-1 col-lg-8 offset-lg-2'>
                                <h1 className={clsx(
                                    'h1-hero',
                                    isWhite ? 'white' : 'blue'
                                )}>
                                    {title}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className='idea-hero-banner__media bg-white'>
                <div className='full-width'>
                    <div className='wrapper'>
                        {isNonWhitespaceString(image?.src) && (
                            <Image
                                src={image?.src}
                                srcMedium={image?.srcMedium}
                                srcSmall={image?.srcSmall}
                                alt={image?.alt}
                                className='cover'
                            />
                        )}
                    </div>
                </div>
            </div>

            <div className='idea-hero-banner__content bg-white'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-10 offset-md-1 col-lg-8 offset-lg-2'>
                            <div
                                className={clsx(
                                    'red-box',
                                    isWhite ? 'white' : 'blue'
                                )}
                                style={{
                                    backgroundColor: bgColor ? bgColor : '#DA291C'
                                }}
                            >

                                {isNonWhitespaceString(counter?.textBefore) && (
                                    <p className='counter h3'>
                                        {counter.textBefore}
                                        <span className='counter-number h1'>{counter.number}</span>
                                        {counter.textAfter}
                                    </p>                                    
                                )}

                                {isNonWhitespaceString(content) && (
                                    <RichText
                                        className='text-big'
                                        content={content}
                                    />
                                )}

                                {cta && (
                                    <LinkList
                                        style='inline'
                                        {...cta}
                                    />
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </Section>
    )
}